<template>
	<b-container fluid>
		<page-title><h2>Dane firmy</h2>
			<div v-if="item && !loading" class="page-title__buttons">
				<router-link :to="{name: 'CompanyUpdate', params: { id: item.id }}" title="Edytuj" class="btn btn-default"><span>Edytuj</span><svg-icon name="edit"/></router-link>
			</div>
		</page-title>

		<div class="col page-element">
			<div v-if="updated" class="alert alert-success" role="status">Dane firmy zostały zmodyfikowane</div>

			<alert-loading v-if="loading"></alert-loading>
			<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

			<div v-if="item && !loading" class="row">
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
						<tr>
							<td>Nazwa</td>
							<td>{{ item['name'] }}</td>
						</tr>
						<tr>
							<td>NIP</td>
							<td>{{ item['nip'] }}</td>
						</tr>
						<tr>
							<td>REGON</td>
							<td>{{ item['regon'] }}</td>
						</tr>
						<tr>
							<td>KRS</td>
							<td>{{ item['krs'] }}</td>
						</tr>
						<tr>
							<td>Numer konta (PLN)</td>
							<td>{{ item['bankAccount']['numberPLN'] }}</td>
						</tr>
						<tr>
							<td>Numer konta (EUR)</td>
							<td>{{ item['bankAccount']['numberEUR'] }}</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
						<tr>
							<td>Adres</td>
							<td>{{ item.address.postalCode }} {{ item.address.city }}, ul. {{ item.address.street }} {{ item.address.number }} {{ item.address.country }}</td>
						</tr>
						<tr>
							<td>Telefon</td>
							<td>{{ item.phone }}</td>
						</tr>
						<tr>
							<td>Strona WWW</td>
							<td>{{ item.website }}</td>
						</tr>
						<tr>
							<td>E-mail</td>
							<td>{{ item.email }}</td>
						</tr>
						<tr v-if="item.summary">
							<td>Podsumowanie</td>
							<td>{{ item['summary'] }}</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
	import {mapGetters} from 'vuex';

	export default {
    data: function() {
      return {
        updatedShowMessage: false
      }
    },
    computed: mapGetters({
      error: 'company/show/error',
      loading: 'company/show/loading',
      item: 'company/show/item',
      configCompany: 'config/config/company',
      updated: 'company/update/updated',
    }),
    created () {
      this.$store.dispatch('company/show/retrieve', this.configCompany.id);
      if (this.updated != null) {
        this.updatedShowMessage = true
        setTimeout(() => {
          this.updatedShowMessage = false
          this.$store.dispatch('company/update/reset');
        }, 5000)
      }
	  
    },
    beforeDestroy() {
      this.$store.dispatch('company/show/reset');
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?25577e22